'use strict';

const SELECTORS = {
    SHORTHAND: '.fullwidth-embed'
};

function init() {
    let el = document.querySelector(SELECTORS.SHORTHAND);

    if (!el) { return false; }

    document.body.classList.add('shorthand-embed-body');
}

module.exports = {
    init: init
}